// extracted by mini-css-extract-plugin
module.exports = {"root":"MainPage_root__3u3GX"};